import React from "react";
import { techStack } from "../data/mock";

const TechStack = () => {
  const doubled = [...techStack, ...techStack];
  return (
    <section id="tech" className="py-24 section-gradient overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="mono-pixel text-[#ffcb05] tracking-[0.3em] text-sm mb-3">// TECH STACK</p>
          <h2 className="pixel-font text-2xl sm:text-3xl text-white title-deco">BUILT WITH MODERN TOOLS</h2>
          <p className="text-white/60 mt-6 max-w-2xl mx-auto">
            Svelte 5, Three.js and Threlte power a slick 2.5D experience that runs entirely in your browser.
          </p>
        </div>
      </div>

      <div className="relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none" style={{background: "linear-gradient(to right, #0b1626, transparent)"}} />
        <div className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none" style={{background: "linear-gradient(to left, #0b1626, transparent)"}} />
        <div className="flex gap-4 marquee-track w-max">
          {doubled.map((t, i) => (
            <div key={i} className="shrink-0 px-6 py-4 rounded-lg border border-white/10 bg-white/[0.04] min-w-[180px]">
              <div className="pixel-font text-[#ffcb05] text-xs">{t.name}</div>
              <div className="text-[11px] uppercase tracking-wider text-white/45 mt-1">{t.category}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
